<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-03-11 11:48:06
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-11 15:56:53
 * @FilePath: /chaoyongtuan/src/views/shopManage/shopLibrary/list/tableCells/materLinkCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="yx-color-primary cursor-pointer" @click="jumpMaterial(row)"> {{ row.material_count | formatEmpty }}</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';

export default {
	mixins: [mixin],
	
	methods: {
        jumpMaterial(row){
            if( +row.third_product_id === 0) return
            this.$router.push(`/libray/local/list?batch=0&platformId=${row.platform_id}&thirdProductId=${row.third_product_id}`);
        },
	},
};
</script> 